import i18next from "i18next";
import { URLS } from "../API/API endpoints";
import axiosInstance from "../AxiosInstance";

export const getHomeDashData = async (company_id, startDate, endDate) => {
  try {
    const payload = {
      company_id: company_id,
      start_date: startDate,
      end_date: endDate,
    };

    const response = await axiosInstance.post(URLS.GET_HOME_DASH_DATA, payload);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const getUserOnboarding = async (company_id) => {
  try {
    const payload = {
      company_id: company_id,
    };

    const response = await axiosInstance.post(
      URLS.CHECK_USER_ONBOARDING,
      payload
    );

    return response.data;
  } catch (error) {
    return error;
  }
};

export const getStorePaymentData = async (company_id) => {
  try {
    const payload = {
      company_id: company_id,
    };

    const response = await axiosInstance.post(
      URLS.GET_STORE_PAYMENT_DATA,
      payload
    );

    return response.data;
  } catch (error) {
    return error;
  }
};

export const getLahloobHomeDashData = async (
  company_id,
  startDate,
  endDate
) => {
  try {
    const payload = {
      store_id: company_id,
      start_date: startDate,
      end_date: endDate,
    };

    const response = await axiosInstance.post(
      URLS.GET_LAHLOOB_HOME_DASH_DATA,
      payload
    );

    //   console.log("DDDDDDDD",response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const getPurchaseDashData = async (userID) => {
  try {
    const payload = {
      user_id: userID,
    };

    const response = await axiosInstance.post(URLS.PURCHASE_DASHBOARD, payload);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const logButtonClick = async (user_id, company_id, moduleName) => {
  // console.log("API VALUEEESSS", values);

  try {
    // user_id:login.user?.userDetails?.user_id,
    const payload = {
      user_id: user_id,
      company_id: company_id,
      module_name: moduleName,
      source: "store",
    };
    const response = await axiosInstance.post(URLS.LOG_BUTTON_CLICK, payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getSideBarData = async (userID, companyId, lang) => {
  try {
    const payload = {
      store_id: companyId,
      user_id: userID,
      lang: lang,
    };

    const response = await axiosInstance.post(URLS.SIDEBAR, payload);
   
    return response?.data?.result;
  } catch (error) {
    return error;
  }
};
